export default {
  red: '#f44336',
  blue: '#2196f3',
  green: '#4caf50',
  purple: '#9c27b0',
  black: '#000000',
  grey: '#3B3D40',
  teal: '#009688',
  cyan: '#00bcd4',
  white: '#FFFFFF',


  // Standard Colors
  darkGrey: '#3B3D40',
  midGrey1: '#81858D',
  midGrey3: '#5A5D64',
  midGrey2: '#6D7078',
  lightGrey1: '#F2F3F4',
  lightGrey2: '#DDE1E3',
  lightGrey3: '#CFD3D6',

  // Buttons
  primary: '#006f51',
  primaryHover: '#00A881',
  secondary: '#000000',
  secondaryHover: '#383838',

  // Info Colors
  success: '#4B8400',
  error: '#E31F2D',
  warning: '#FFD364',
  info: '#CFD3D6',

  // Active/Deactive
  active: '#4B8400',
  deactivated: '#6D7078',

  // Style
  aluminium: '#A8ABB1',

  // Tooltips
  tooltipBackground: '#1B1B1D',
  appBarBackground: '#005B46'
};